module.exports = __webpack_public_path__ + "web/img/level-2.c5261040.png";